import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, AfterContentChecked, ChangeDetectorRef } from '@angular/core';
import { RessourcesModel } from '../ressources/models/ressources.model';
import { SitProModel } from '../sitpro/models/sitpro.model';
import { PersonneForm, PersonneModel } from './models/personne.model';
import { ConstantePage } from '../../../constants/constante-page';
import { TypePersonneEnum } from './enum/type-personne.enum';
import { FormGroup, ControlContainer } from '@angular/forms';
import { TagWaService } from '../../../services/tag-wa.service';

@Component({
  selector: 'app-personne',
  templateUrl: './personne.component.html'
})
export class PersonneComponent implements OnInit, OnDestroy, AfterContentChecked {

  @Input() name : string;
  
  /**
   * Type de la personne (demandeur ou conjoint)
   */
  @Input() typePersonne : TypePersonneEnum;

  /**
   * Objet model Personne chargé en provenance du parent
   */
  @Input() personneModel : PersonneModel;

  @Input() nbEnfants = 0;

  /**
   * Remonte un evenement de type booleen informant si la saisie du formulaire du composant est complete et sans erreurs
   */
  @Output() isSaisieCompleteEvent = new EventEmitter<boolean>();

  @Output() personneModelChange = new EventEmitter<PersonneModel>();

  profilRessources = 0;

  typePersonneEnum  = TypePersonneEnum;

  parentForm : FormGroup;
  personneForm : FormGroup<PersonneForm>;
  
  constructor(
    private readonly controlContainer: ControlContainer,
    private readonly tagWaService: TagWaService,
    private readonly cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.personneForm = new FormGroup<PersonneForm>({});
    this.parentForm = this.controlContainer?.control as FormGroup;
    this.parentForm.addControl(this.name, this.personneForm);

    if (this.typePersonne === TypePersonneEnum.CONJOINT) {
      this.profilRessources = 1;
    }

    if (this.personneModel === undefined) {
      this.personneModel = new PersonneModel();
      this.personneModel.typePersonne = this.typePersonne;
      this.personneModel.ressources = new RessourcesModel();
      this.personneModel.sitPro = new SitProModel();
    }
  }

  ngAfterContentChecked() {
    this.cd.detectChanges();
  }
  
  ngOnDestroy() : void {
    this.parentForm.removeControl(this.name);
    this.personneModel = undefined;
    this.personneModelChange.emit(this.personneModel);
  }

  recupererRessources($event : RessourcesModel) {
      const nouveauBeanPersonne = new PersonneModel();
      nouveauBeanPersonne.typePersonne = this.typePersonne;
      nouveauBeanPersonne.ressources = $event;
      nouveauBeanPersonne.sitPro = this.personneModel.sitPro;

      this.personneModel = nouveauBeanPersonne;
      this.personneModelChange.emit(this.personneModel);
  }

  recupererSitPro($event : SitProModel) {
    const nouveauBeanPersonne = new PersonneModel();
    nouveauBeanPersonne.typePersonne = this.typePersonne;
    nouveauBeanPersonne.ressources = this.personneModel.ressources;
    nouveauBeanPersonne.sitPro = $event;

    this.personneModel = nouveauBeanPersonne;
    this.personneModelChange.emit(this.personneModel);
  }
  
  /**
   * Methode pour taguer un clic
   * 
   * Tag de la popup Ressources usager / Conjoint
   */
  clickPopup(typePers) {   
    let typePersonne = ConstantePage.STATS_CLIC_RESSOURCES_USAGER;
    if (typePers === TypePersonneEnum.CONJOINT) {
      typePersonne = ConstantePage.STATS_CLIC_RESSOURCES_CONJOINT;
    }
    
    // On tague la popup Ressources usager / Conjoint pour le WA
    this.tagWaService.tagClic(typePersonne, ConstantePage.STATS_PAGE_DECLARATION);   
  }
}
